
const digest = 'b3dc92fc1cbcba23b46522b33658db30a35eb5501e2f773b9eaa0afa07e5b595';
const classes = {"dateAndTimeWrapper":"_dateAndTimeWrapper_1slge_1","weightDetails":"_weightDetails_1slge_7","weightField":"_weightField_1slge_17","requiredFields":"_requiredFields_1slge_26","pressureWrapper":"_pressureWrapper_1slge_36","unitWrapper":"_unitWrapper_1slge_47","unitDescription":"_unitDescription_1slge_56","unitTitle":"_unitTitle_1slge_64","unit":"_unit_1slge_47","slashWrapper":"_slashWrapper_1slge_74","field":"_field_1slge_83"};
const css = `._dateAndTimeWrapper_1slge_1 {
  display: flex;
  flex-direction: row;
  gap: 20px;
}

._weightDetails_1slge_7 {
  display: flex;
  margin: 16px 0;
}
@media (max-width: 1200px) {
  ._weightDetails_1slge_7 {
    flex-direction: column;
  }
}

._weightField_1slge_17 {
  margin-right: 24px;
}
@media (max-width: 1200px) {
  ._weightField_1slge_17 {
    margin-bottom: 16px;
  }
}

._requiredFields_1slge_26 {
  color: #3e3f42;
  font-weight: 400;
  font-size: 14px;
  margin: 0 0 3px 0;
  font-family: Rubik, sans-serif;
  padding-bottom: 5px;
  display: flex;
}

._pressureWrapper_1slge_36 {
  display: flex;
  align-items: center;
}
@media (max-width: 1200px) {
  ._pressureWrapper_1slge_36 {
    flex-direction: column;
    align-items: flex-start;
  }
}

._unitWrapper_1slge_47 {
  display: flex;
}
@media (max-width: 1200px) {
  ._unitWrapper_1slge_47 {
    margin-bottom: 12px;
  }
}

._unitDescription_1slge_56 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-right: 8px;
}

._unitTitle_1slge_64 {
  font-family: Rubik, sans-serif;
  font-size: 16px;
}

._unit_1slge_47 {
  font-family: Rubik, sans-serif;
  font-size: 12px;
}

._slashWrapper_1slge_74 {
  margin: 0 8px;
}
@media (max-width: 1200px) {
  ._slashWrapper_1slge_74 {
    display: none;
  }
}

._field_1slge_83 {
  margin-bottom: 14px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  